<!-- mainRecomProd -->
<div class="mainRecomProd">
    <div class="mainRecom">
        <h2 class="bTit">
            <span>Recommend Products</span>
            추천 상품
        </h2>
        <div class="recomSlide">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" *ngFor="let item of mapPdt | keyvalue; index as i">
                        <ul>
                            <ng-container *ngFor="let item2 of item.value; index as j">
                                <li [product]="item2" [typeTemplate]="'pdtRecomm'" [number]="i * 5 + j + 1"></li>
                            </ng-container>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
        </div>
    </div>
</div>
<!-- //mainRecomProd -->